var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('backbone.marionette');

var DeferEntity = Marionette.Object.extend({
    constructor: function(Entity) {
        this.Entity = Entity;
        this.instance = null;
    },
    bindInstanceEvents: function() {
        this.listenTo(this.instance, 'all', function() {
            this.trigger.apply(this, arguments);
        });
    },
    unbindInstanceEvents: function() {
        this.stopListening(this.instance);
    },
    makeNewInstance: function(attributes, options) {
        this.unbindInstanceEvents();
        this.instance = new this.Entity(attributes, options);
        this.bindInstanceEvents();
    },
    makeSuccessCallback: function(defer, delay) {
        var timestamp = Date.now();

        return function(entity) {
            var timeElapsed = Date.now() - timestamp;

            if (delay && delay - timeElapsed > 0) {
                setTimeout(function() {
                    defer.resolve(entity);
                }, delay - timeElapsed);
            } else {
                defer.resolve(entity);
            }
        };
    },
    makeErrorCallback: function(defer) {
        return function(entity, response) {
            defer.reject({ errorCode: response.status });
        };
    },
    defer: function(options) {
        var options = options || {};
        var defer = $.Deferred();
        var delay = options.delay;
        var entityAttributes = options.entityAttributes; // attributes - or models - passed into the object
        var entityOptions = options.entityOptions; // options passed into the object
        var fetchOptions = options.fetchOptions || {};

        // If {returnInstance: true} return the actual instance instead of the resolved promise
        if (options.returnInstance) {
            if (!this.instance) {
                this.makeNewInstance(entityAttributes, entityOptions);
            }

            return this.instance;
        }

        this.makeNewInstance(entityAttributes, entityOptions);

        _.defaults(fetchOptions, {
            success: this.makeSuccessCallback(defer, delay),
            error: this.makeErrorCallback(defer),
        });

        // Fetch model, return a promise
        this.instance.fetch(fetchOptions);

        return defer;
    },
});

module.exports = DeferEntity;
